(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-tt-card]')];
    const groups = [...root.querySelectorAll('[data-tt-group]')];
    const search = root.querySelector('[data-tt-search]');
    function filter() {
      const term = (search?.value || '').trim().toLowerCase();
      let count = 0;
      cards.forEach(card => {
        const show = card.dataset.title.toLowerCase().includes(term);
        card.hidden = !show;
        if (show) count++;
      });
      groups.forEach(group => {
        group.hidden = ![...group.querySelectorAll('[data-tt-card]')].some(card => !card.hidden);
      });
      root.querySelector('[data-tt-empty]').hidden = count > 0;
    }
    search?.addEventListener('input', filter);
    const dialog = root.querySelector('[data-tt-dialog]');
    let opener;
    root.querySelectorAll('[data-tt-detail]').forEach(button => button.addEventListener('click', () => {
      opener = button;
      root.querySelector('[data-tt-dialog-title]').textContent = button.closest('[data-tt-card]').dataset.title;
      dialog.showModal();
    }));
    root.querySelector('[data-tt-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => opener?.focus());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    filter();
  }
  document.querySelectorAll('[data-tt-store]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-tt-store]').forEach(initialize));
})();
